import React from 'react';
import Link from 'next/link';

interface Props {
  anchorTagRef: string;
}

const AnchorLink = ({ anchorTagRef }: Props) => {
  return (
    <div>
      {anchorTagRef && (
        <Link
          id={anchorTagRef}
          href={`#${anchorTagRef}`}
          className="invisible relative top-[5rem] block scroll-mt-standard"
        />
      )}
    </div>
  );
};

export default AnchorLink;
